import React, { createContext, useContext, useState, ReactNode } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getStorage, ref, uploadString } from "firebase/storage";
 
interface ModalContextType {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [showModal, setShowModal] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const handleClose = () => setShowModal(false);

  const handleSubmitAdditionalInfo = async () => {
    const formData = {
      name,
      phone,
      email,
      website,
      timestamp: Date.now(),
    };

    try {
      const storage = getStorage();
      const storageReference = ref(storage, `form_submissions/${formData.timestamp}.json`);
      const jsonString = JSON.stringify(formData, null, 2);
      await uploadString(storageReference, jsonString, "raw", { contentType: "application/json" });

      // Clear form and close modal after successful upload      setName("");
      setPhone("");
      setEmail("");
      setWebsite("");
      setShowModal(false);
    } catch (error) {
      // Handle error (e.g., show an error message to the user)      
    }
  };

  return (
    <ModalContext.Provider value={{ showModal, setShowModal }}>
      {children}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Additional Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                value={phone}
                placeholder="Enter your phone number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Website</Form.Label>
              <Form.Control
                type="url"
                value={website}
                placeholder="Enter your website URL"
                onChange={(e) => setWebsite(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmitAdditionalInfo}>
            Submit
          </Button>
          {/* Add a button here to submit the additional information if needed */}
          {/* <Button variant="primary" onClick={handleSubmitAdditionalInfo}>
            Submit
          </Button> */}
        </Modal.Footer>
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext); 
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};